import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useEffect, useState} from "react";
import ApiService from "../../../core/service/api-service";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import logColumns from "./LogColumns";
import {useTranslation} from "react-i18next";
import {Button, message, Spin} from "antd";
import {NumberOutlined} from "@ant-design/icons";
import JsonViewModal from "../../../core/components/JsonViewModal";

export default function LogGrid()
{
    const {t} = useTranslation();
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();
    const [exactCount, setExactCount] = useState(null);
    const [countLoading, setCountLoading] = useState(false);
    const [jsonModalVisible, setJsonModalVisible] = useState(false);
    const [selectedJson, setSelectedJson] = useState(null);

    const handleViewJson = (data) => {
        setSelectedJson(data);
        setJsonModalVisible(true);
    };

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: logColumns(t, handleViewJson),
        })
    }, [])

    const getLogGrid = async () => {
        setExactCount(null);
        const response = await ApiService.Log.GetDataGrid(queryModel);
        if(response.success)
        {
            setData(response.data);
            setPaginationResult(response.pagination)
        }
    }

    const getExactCount = async () => {
        setCountLoading(true);
        const response = await ApiService.Log.GetCount(queryModel.filter);
        setCountLoading(false);
        if(response.success)
        {
            setExactCount(response.data);
            message.success(`${t('exactCount')}: ${response.data.toLocaleString()}`);
        }
    }

    useEffect(() => {
        getLogGrid()
    }, [queryModel.updateKey])

    return (
        <>
            <div style={{marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8}}>
                <Button 
                    icon={<NumberOutlined />} 
                    onClick={getExactCount} 
                    loading={countLoading}
                    size="small"
                >
                    {t('getExactCount')}
                </Button>
                {exactCount !== null && (
                    <span style={{fontWeight: 'bold'}}>
                        {t('exactCount')}: {exactCount.toLocaleString()}
                    </span>
                )}
            </div>
            <DataGrid name={'log'}/>
            <JsonViewModal 
                visible={jsonModalVisible} 
                data={selectedJson} 
                onClose={() => setJsonModalVisible(false)}
                title={t('Log Data')}
            />
        </>
    )
}
